export default __webpack_public_path__ + "static/media/ismsf.e959fcdb.png";